
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';;
import { Subject } from "rxjs/Subject";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as _ from 'lodash';

/** Query file */
import { UserQueryService } from '../../queryFiles/users';
import { ScheduleQueryService } from '../../queryFiles/scheduleRequest';
import { BookingsQueryService } from '../../queryFiles/scheduleBookings';

import { SolutionFormService } from '../solutionForm/solutionForm.service';

import { orders } from '../../utils/index';


@Injectable()
export class AssignProService implements Resolve<any>
{

    currentOrdeId: BehaviorSubject<any> = new BehaviorSubject('');
    orderStatus: BehaviorSubject<any> = new BehaviorSubject({ loading: true, details: {} });
    viewChanged: Subject<any> = new Subject;
    assignAnotherProChanged: Subject<any> = new Subject;
    routeParams: any;
    onAllProUsers: BehaviorSubject<any> = new BehaviorSubject({ loading: true, users: [] });

    ordersValues = orders;

    constructor(
        public solutionFormService: SolutionFormService,

        /**Query files */
        public userQueryService: UserQueryService,
        public scheduleQueryService: ScheduleQueryService,
        public bookingsQueryService: BookingsQueryService
    ) {
    }

    /**
     * The Academy App Main Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;
        this.orderStatus.next({ loading: true, users: [] });
        return new Promise((resolve, reject) => {
            Promise.all([
            ]).then(
                () => {
                    if (this.routeParams) {
                        this.getCurrentOrder()
                    }
                    resolve('');
                },
                reject
            );
        });
    }

    getCurrentOrder() {
        /** 
         *    get current order from params
         */
        this.currentOrdeId.next(this.routeParams.id);
        this.getOrderDetails(this.routeParams.id)
    }

    getOrderDetails(id) {
        return new Promise((resolve, reject) => {
            /** Check order assigned to pro or not */
            this.solutionFormService.checkOrderStatus(id)
                .then((data: any) => {

                    if (data.length > 0) {
                        data.map(res => {
                            this.orderStatus.next({ loading: false, details: res.node });
                        })
                    }
                    resolve(data);
                })
                .catch(() => {
                    reject;
                })
        })
    }

    /**
     * Get all pro type users
     * @param userType -Based on usertype fetching data
     */
    GetAllProUsers(userType) {
        return new Promise((resolve, reject) => {
            this.userQueryService
                .GET_ALL_PRO_USERS(userType)
                .valueChanges
                .subscribe((res: any) => {
                    var proUsers = [];
                    if (res.data.allRoles.edges.length > 0) {
                        var responseData = res.data.allRoles.edges[0].node.usersByRoleId.edges;
                        _.each(responseData, data => {
                            proUsers.push(data.node);
                            if (responseData.length == proUsers.length) {
                                this.onAllProUsers.next({ loading: false, users: proUsers });
                            }
                        })
                        resolve('success');
                    }
                }, err => {
                    reject(err);
                });
        });
    }

    /**
     *  Changed status of orders both ScheduleRequests & ScheduledBookings
     * @param orderId 
     * @param userId 
     */
    changeStatusOfOrder(orderId, userId) {
        
        return new Promise((resolve, reject) => {
            //1.get Nodeid  to update
            this.getOrderDetails(orderId)
                .then((response: any) => {
                
                    var responseData = response;
                    if (responseData.length > 0) {
                        //2.Update row with nodeid
                        this.scheduleQueryService
                            .UPDATE_REQUEST_STATUS_BY_OWNER(responseData[0].node.nodeId, userId)
                            .subscribe(() => {
                                //3.get row of allScheduledBookings
                                this.bookingsQueryService
                                    .GET_SCHEDULE_BOOKING_BY_ORDERID(orderId)
                                    .valueChanges
                                    .subscribe((response: any) => {
                                        var responseData1 = response.data.allScheduledBookings.edges;
                                        if (responseData1.length > 0) {
                                            //4.Update row of allScheduledBookings
                                            this.bookingsQueryService
                                                .UPDATE_SCHEDULE_BOOKING_BY_OWNER(responseData1[0].node.nodeId, userId)
                                                .subscribe(afterUpdate => {
                                                    resolve(responseData1);
                                                }, err => {
                                                    reject(err);
                                                })
                                        } else { //currently add -Bec web hook not called immediatly
                                            resolve(responseData);
                                        }

                                    }, err => {
                                        reject(err);
                                    })
                            }, err => {
                                reject(err);
                            });
                    } else {
                        resolve([]);
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }
    getOrderFromOrderStatus(orderId){
        return new Promise((resolve, reject) => {
            this.scheduleQueryService.GET_ID(orderId).valueChanges
            .subscribe((response:any)=>{
                resolve(response);
            })
        });
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/assignPro/assignPro.service.ts